import React from 'react';
import PropTypes from 'prop-types';
import {Portal} from "../../../../BaseComponents/Portal/Portal";

const contextMenuStyles = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    zIndex: 3000,
    padding: '5px 0',
    maxWidth: 100,
    left: 'auto'
};

const menuItemStyles = {
    padding: '8px 16px',
    cursor: 'pointer',
};

export class MessageContextMenu extends React.Component {

    handleDocumentClick = (e) => {
        if (this.props.show) {
            this.props.onClose();
        }
    }

    handleActionClick = action => _ => {
        action.onClick(this.props.message);
        this.props.onClose();
    }

    render() {
        if (!this.props.show) {
            return '';
        }

        const {top, right} = this.props.position;

        return (
            <Portal domNode={document.body}>
                <div className={"message-context-menu dropdown-menu show"} style={{...contextMenuStyles, top, right}} onClick={e => e.stopPropagation()}>
                    {this.props.actions.map((action, index) => (
                        <div
                            key={index}
                            style={menuItemStyles}
                            className={"dropdown-item"}
                            onMouseOver={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                            onMouseOut={e => e.currentTarget.style.backgroundColor = 'white'}
                            onClick={this.handleActionClick(action)}>
                            {action.text}
                        </div>
                    ))}
                </div>
            </Portal>
        );
    }
}

MessageContextMenu.propTypes = {
    show: PropTypes.bool.isRequired,
    position: PropTypes.shape({
        top: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired
    }).isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
    })).isRequired,
    message: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
};
